<span
    [ngClass]="{
        'lead-type-warm': isWarm === 1,
        'lead-type-cold': isWarm !== 1
    }"
    >&#9679;&nbsp;{{ isWarm ? 'Warm Lead' : 'Cold Lead' }}</span
>
